import { render, staticRenderFns } from "./console.vue?vue&type=template&id=a4bee146&scoped=true"
import script from "./console.vue?vue&type=script&lang=js"
export * from "./console.vue?vue&type=script&lang=js"
import style0 from "./console.vue?vue&type=style&index=0&id=a4bee146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bee146",
  null
  
)

export default component.exports